import "react-phone-input-2/lib/high-res.css";
import PhoneInput from "react-phone-input-2";
import { parsePhoneNumberFromString } from "libphonenumber-js";

export default function PhoneInputField({
  postPhoneNumber,
  formData,
  setFormData,
  bothLoginEnabled,
}) {

  const handleChange = (value, data) => {
    const full = "+" + value;
    const phone = parsePhoneNumberFromString(full);

    setFormData(prev => ({
      ...prev,
      mobile_num: phone?.number || full,
      is_valid: phone?.isValid() || false,
      country_code: "+" + data.dialCode,
      country: data.countryCode,
      country_full_name: data.name,
    }));
  };

  return (
    <div className="w-full rounded-xl bg-gray-50 text-black">
      <PhoneInput
        placeholder="Enter phone number"
        value={formData.mobile_num}
        country="in"
        enableSearch
        onChange={handleChange}
        inputStyle={{
          borderRadius: bothLoginEnabled ? "0px" : "5px",
        }}
        inputProps={{
          onKeyDown: (e) => e.key === "Enter" && postPhoneNumber(),
        }}
      />
    </div>
  );
}